import { EventEmitter } from 'events';

export enum BaseMediaEvents {
  Ready = 'ready',
  Destroy = 'destroy',
  Error = 'error',
  Play = 'play',
  Pause = 'pause',
  Ended = 'ended',
  Timeupdate = 'timeupdate',
  // Buffered = 'buffered',

  Change_Resource = 'change:resource',
  Change_Playing = 'change:playing',
  Change_Time = 'change:time',
  Change_Mute = 'change:mute',
  Change_Volume = 'change:volume',
  Change_Loop = 'change:loop',
  // Change_Level = 'change:level',
}

abstract class BaseMedia extends EventEmitter {
  public uid: string;

  constructor(resourceUID: string) {
    super();
    this.uid = resourceUID;
  }

  abstract destroy(): void;

  // action methods

  abstract play(): void;

  abstract pause(): void;

  abstract mute(): void;

  abstract unmute(): void;

  // setter methods

  abstract setResource(src: any): void;

  abstract setCurrentTime(time: number): void;

  abstract setVolume(volume: number): void;

  abstract setLoop(value: boolean): void;

  // getter methods

  abstract getCurrentTime(): number;

  abstract getDuration(): number;

  abstract getVolume(): number;

  abstract isPaused(): boolean;

  abstract isMuted(): boolean;

  abstract isLoop(): boolean;
}

export default BaseMedia;
